// SingleJobs.jsx
import React from "react";
import { Link } from "react-router-dom";
import RightArrow from "../SVG";
import blogBG from "../../assets/img/blog/bg-1.jpg";

const SingleJobs = ({
  jobtitle,
  description,
  experience,
  location,
  postedDate,
  hasArrow,
  link,
  stateData,
}) => {
  return (
    <div
      className="it-blog-item-box"
      style={{ backgroundImage: `url(${blogBG})` }}
    >
      <div className="it-blog-item">
        <div className="it-blog-meta pb-15">
          <span>
            <i className="fa-solid fa-calendar-days"></i>
            {postedDate}
          </span>
          <span>
            <i className="fa-solid fa-location-dot"></i>
            {location}
          </span>
          <span>
            <i className="fa-solid fa-file-certificate"></i>
            {experience}
          </span>
        </div>

        <h4 className="it-blog-title">
          <Link to={link} state={stateData}>
            {jobtitle}
          </Link>
        </h4>

        <div className="it-about-text prose">{description}</div>

        <Link className="ed-btn-blog mt-2" to={link} state={stateData}>
          Apply Now
          {hasArrow && (
            <i>
              <RightArrow />
            </i>
          )}
        </Link>
      </div>
    </div>
  );
};

export default SingleJobs;
